import DashBoard from "../Views/Pages/Dashboard"
import AuthGuard from "../Shared-ui/utils/Routes/AuthGuard"
import MainLayout from "../Shared-ui/Layout/MainLayout"
import UserProfile from "../Views/Pages/UserProfile";
import { UserContextProvider } from "../Shared-ui/Context/UserContext";
import OldAgent from "../Views/Pages/OldAgent";
import AiPrompts from "../Views/Pages/AiPrompts";
import { CommonContextProvider } from "../Shared-ui/Context/CommonContext";
import Groups from "../Views/Components/Groups";

import AgentPlayground from "../Views/Pages/AgentPlayground";
import KnowledgeBases from "../Views/Pages/KnowledgeBases";
import Tools from "../Views/Pages/Tools";
import Agents from "../Views/Pages/Agents";
import MultiAgentPlayground from "../Views/Pages/MultiAgentPlayground";
import ZealogicsApp from "../Views/Pages/ZealogicsApp";
import DashboardAnalytics from "../Views/Pages/DashboardAnalytics";
import Help from "../Views/Pages/Help";
import CreateAgent from "../Views/Pages/CreateAgent";
import Workflows from "../Views/Pages/Workflows";
import WorkflowBuilderWrapper from "./WorkflowBuilderWrapper";
import CreateMultiAgent from "../Views/Pages/CreateMultiAgent";

// const DashBoard = React.lazy(() => import('../Views/Pages/Dashboard'));

const AutherizedRoutes = {

    // path: '/',
    element: (
        <AuthGuard>
            <CommonContextProvider>
                <UserContextProvider>
                    <MainLayout />
                </UserContextProvider>
            </CommonContextProvider>
        </AuthGuard>),
    children: [
        {
            path: '/home',
            element: <DashBoard />
        },
        // {
        //     path: '/agents',
        //     element: <Agents />
        // },
        {
            path: '/agents',
            element: <Agents />
        },
        {
            path: '/agents/create-agent',
            element: <CreateAgent />
        },
        {
            path: '/agents/create-agent/:agentId',
            element: <CreateAgent />
        },
        {
            path: '/workflows',
            element: <Workflows />
        },
        {
            path: '/workflows/create',
            element: <WorkflowBuilderWrapper />
        },
        {
            path: '/workflows/edit/:workflowId',
            element: <WorkflowBuilderWrapper />
        },
        {
            path: '/multi-agents/create-multi-agent',
            element: <CreateMultiAgent />
        },
        {
            path: '/multi-agents/create-multi-agent/:teamId',
            element: <CreateMultiAgent />
        },
        {
            path: '/userprofile',
            element: <UserProfile />
        },
        {
            path: '/prompts',
            element: <AiPrompts />
        },

        // {
        //     path: '/settings',
        //     element: <Settings />
        // },
        {
            path: '/groups',
            element: <Groups />
        },
        {
            path: '/agent/:agentId',
            element: <OldAgent />
        },
        {
            path: '/playground/agent/:agentId',
            element: <AgentPlayground />
        },
        {
            path: '/playground/teams/:teamsId',
            element: <MultiAgentPlayground />
        },
        {
            path: '/knowledge-bases',
            element: <KnowledgeBases />
        },
        {
            path: '/tools',
            element: <Tools />
        },
        {
            path: '/app',
            element: <ZealogicsApp />
        },
        {
            path: '/dashboard-analytics',
            element: <DashboardAnalytics />
        },
        {
            path: '/help',
            element: <Help />
        },

    ]

}




// const AutherizedRoutes = [
//     {
//         element: (
//             <GuestGuard>
//                 <MinimalLayout />
//             </GuestGuard>),
//         children: [
//             {
//                 path: '/',
//                 element: <Login />
//             },
//             {
//                 path: '/register',
//                 element: <Register />
//             },
//             {
//                 path: '/forgot',
//                 element: <PasswordReset />
//             },
//             {
//                 path: '/getstarted',
//                 element: <PasswordReset />
//             },



//         ]
//     },
//     {
//         element: (
//             <AuthGuard>
//                 <MainLayout />
//             </AuthGuard>),
//         children: [
//             {
//                 path: '/home',
//                 element: <DashBoard />
//             },
//             {
//                 path: '/agents',
//                 element: <Agents />
//             },


//         ]
//     },
//     {
//         element:(
//             <>
//             <Outlet/>
//             </>
//         ),
//         children: [
//             {
//                 path: '*',
//                 element: <NotFound />
//             },


//         ]
//     }

// ]

export default AutherizedRoutes